module.exports = __webpack_public_path__ + "static/media/ceo_cn.743a5450.png";